import Splide from '@splidejs/splide';

// Функція для ініціалізації слайдера
function initializeSlider() {
    /**
     * Splide .articles-category mobile sliders executer
     */
    const splideElms = document.querySelectorAll('.articles-category-slider.splide');

    if (splideElms.length) {
        for (var i = 0; i < splideElms.length; i++) {
            new Splide(splideElms[i], {
                perPage: 1.2,
                focus: 0,
            }).mount();
        }
    }

    const slidersWithThumbnails = document.getElementsByClassName('image-slider-with-thumbnails');
    if (slidersWithThumbnails.length > 0) {
        for (let i = 0; i < slidersWithThumbnails.length; i++) {
            const secondarySliderEl = slidersWithThumbnails[i].querySelector('.secondary-slider');
            const secondarySlider = new Splide(secondarySliderEl, {
                rewind: true,
                fixedWidth: 100,
                fixedHeight: 64,
                isNavigation: true,
                gap: 10,
                focus: 'center',
                pagination: false,
                arrows: false,
                cover: true,
                breakpoints: {
                    '600': {
                        fixedWidth: 66,
                        fixedHeight: 40,
                    }
                }
            }).mount();

            const primarySliderEl = slidersWithThumbnails[i].querySelector('.primary-slider');
            const primarySlider = new Splide(primarySliderEl, {
                type: 'fade',
                // heightRatio: 0.5,
                rewind: true,
                pagination: false,
                arrows: true,
                cover: true,
            });

            // Встановити слайдер мініатюр як ціль синхронізації та викликати mount.
            primarySlider.sync(secondarySlider).mount();
        }
    }
}

// Виклик функції після завантаження нового посту або виконання AJAX-запиту
document.addEventListener("DOMContentLoaded", function () {
    let counter = 0;
    let counter2 = 0;
    const initialArticle = document.querySelector('.post__single');
    const initialPostTitle = initialArticle ? initialArticle.dataset.posttitle : '';
    const titleSuffix = initialPostTitle && document.title.indexOf(initialPostTitle) === 0
        ? document.title.slice(initialPostTitle.length)
        : '';
    let activePostId = initialArticle ? initialArticle.dataset.postId : null;
    let previousPageUrl = window.location.href;

    function activateArticle(article) {
        const postId = article.dataset.postId;
        const postURL = article.dataset.posturl;
        const postTitle = article.dataset.posttitle;

        if (!postId || !postURL || !postTitle || postId === activePostId) {
            return;
        }

        const pageReferrer = previousPageUrl;
        const pageTitle = postTitle + titleSuffix;

        // Update browser state before notifying GTM.
        document.title = pageTitle;
        history.replaceState({postId: postId}, pageTitle, postURL);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'virtual_page_view',
            page_location: postURL,
            page_title: pageTitle,
            page_referrer: pageReferrer,
            post_id: postId
        });

        activePostId = postId;
        previousPageUrl = postURL;
    }

    // A narrow horizontal band marks the article the user is currently reading.
    // The same observer works while scrolling both down and up.
    const articleObserver = new IntersectionObserver((entries) => {
        const visibleArticles = entries
            .filter(entry => entry.isIntersecting)
            .sort((a, b) => Math.abs(a.boundingClientRect.top) - Math.abs(b.boundingClientRect.top));

        if (visibleArticles.length) {
            activateArticle(visibleArticles[0].target);
        }
    }, {
        root: null,
        rootMargin: '-35% 0px -64% 0px',
        threshold: 0
    });

    function observeArticles(root = document) {
        root.querySelectorAll('.post__single').forEach(article => {
            if (article.dataset.analyticsObserved !== 'true') {
                article.dataset.analyticsObserved = 'true';
                articleObserver.observe(article);
            }
        });
    }

    observeArticles();

    function load_address(val, dataCountShow, showNext = true) {
        // console.log(dataCountShow + " " + val + " " + showNext);
        var value = val ? val : 0;

        var data = new FormData();
        data.append('action', 'get_more_post');
        data.append('id', value);
        data.append('showNext', showNext);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', myajax.url, true);
        if (counter < dataCountShow) {
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    if (response) {
                        if (response == '') {
                            return 'State not found. Please try again.';
                        }
                        var contacts = document.getElementById('more-item');
                        contacts.innerHTML = contacts.innerHTML + response;
                        initializeSlider();
                        observeArticles(contacts);
                    } else {
                        console.log('Немає');
                    }
                } else {
                    console.log('Request failed.  Returned status of ' + xhr.status);
                }
            };
            counter++;
        } else {
            // Отримати елемент з id "click-me"
            var clickMeElement = document.getElementById('click-me');
            // Очистити текст всередині цього елемента
            clickMeElement.textContent = '';
        }
        xhr.onerror = function () {
            console.log('Request failed');
        };
        xhr.send(data);
    }

    function load_address_5(val, dataCountShow, showNext = true) {

        var value = val ? val : 0;
        var data = new FormData();
        data.append('action', 'get_more_post_5');
        data.append('id', value);
        data.append('count', dataCountShow);
        data.append('showNext', showNext);


        var xhr = new XMLHttpRequest();
        xhr.open('POST', myajax.url, true);
        if (counter2 >= 0) {
            xhr.onload = function () {
                if (xhr.status === 200) {
                    var response = xhr.responseText;
                    if (response) {
                        if (response == '') {
                            return 'State not found. Please try again.';
                        }
                        var contacts = document.getElementById('more-item');

                        contacts.innerHTML = contacts.innerHTML + response;
                        initializeSlider();
                        observeArticles(contacts);


                        var clickMeElement = document.getElementById('click-me');
                        // Очистити текст всередині цього елемента
                        clickMeElement.textContent = '';
                    } else {
                        console.log('Немає');
                    }
                } else {
                    console.log('Request failed.  Returned status of ' + xhr.status);
                }
            };
            counter2++;
        } else {
            // Отримати елемент з id "click-me"
            var clickMeElement = document.getElementById('click-me');
            // Очистити текст всередині цього елемента
            clickMeElement.textContent = '';
        }
        xhr.onerror = function () {
            console.log('Request failed');
        };
        xhr.send(data);
    }

    let countLoad = 0;
    const observer = new IntersectionObserver((entries) => {
        function loadMore() {
            let clickMeElement = document.getElementById('click-me');
            let dataCountShow = +clickMeElement.getAttribute('data-counter');

            if (dataCountShow != 0) {
                const postSection = document.querySelector('.post[data-loadpost]');
                let loadPostValue = '';
                if (postSection) {
                    loadPostValue = postSection.getAttribute('data-loadpost');
                }

                if (countLoad == 0 && loadPostValue != '') {
                    // dataCountShow = dataCountShow;
                    // console.log('TEst One');
                    load_address(loadPostValue, dataCountShow, false);
                } else {
                    let clickMeElement = document.getElementById('click-me');
                    let nextShow = clickMeElement.getAttribute('data-next');
                    clickMeElement.setAttribute('data-next', '');
                    // console.log('test Two');
                    clickMeElement.setAttribute('data-counter', 0);
                    load_address_5(nextShow, dataCountShow, true);


                    // setTimeout(function () {
                    //     let articleItems = document.querySelectorAll('#more-item .article-item');
                    //     let lastArticleItem = articleItems[articleItems.length - 1];
                    //     let dataNextAttributeValue = lastArticleItem.getAttribute('data-next');
                    //     let clickMeElement = document.getElementById('click-me');
                    //     clickMeElement.setAttribute('data-next', dataNextAttributeValue);
                    // }, 1500);


                }
            }

            countLoad++;
        }

        entries.forEach(entry => {
            // Перевірка, чи елемент є у зоні видимості
            // console.log(entry);
            // console.log(entry.isIntersecting);
            if (entry.isIntersecting) {
                // Виклик функції loadMore() якщо елемент у зоні видимості
                loadMore();
            }
        });
    }, {
        root: null, // Спостереження за вікном перегляду
        rootMargin: '0px 0px 700px 0px', // Початок підвантаження на 500 пікселів раніше
        threshold: 0 // Тільки один піксель повинен бути у видимій зоні для активації
    });

    const section = document.getElementById('click-me');
    if (section) {  // Перевірка, чи існує секція
        observer.observe(section);
    }

    // Обробник подій для повернення назад в історії
    // window.addEventListener('popstate', function (event) {
    //     if (event.state && event.state.url) {
    //         load_address(event.state.url, document.getElementById('click-me').getAttribute('data-counter'));
    //     }
    // });
});

// Додаємо обробник подій до батьківського контейнера, наприклад, document.body
document.body.addEventListener('click', function (event) {
    // Перевіряємо, чи клікнуто на елемент з класом '.copy-url'
    if (event.target && event.target.classList.contains('copy-url')) {
        event.preventDefault(); // Заборона стандартної дії посилання

        // Отримання батьківського елемента <a> з класом '.social-share__link'
        var parentLink = event.target.closest('a.social-share__link');

        // Перевірка, чи знайдено батьківський елемент
        if (parentLink) {
            // Отримання значення дата-атрибута 'data-url' з батьківського елемента
            var urlToCopy = parentLink.getAttribute('data-url');

            // Створення нового елементу для копіювання URL в буфер обміну
            var tempInput = document.createElement('input');
            tempInput.setAttribute('value', urlToCopy);
            document.body.appendChild(tempInput);

            // Вибір тексту у введенні
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); /* Для мобільних пристроїв */

            // Копіювання тексту у вибраний діапазон
            document.execCommand('copy');

            // Видалення тимчасового елементу
            document.body.removeChild(tempInput);

            // Виведення повідомлення про копіювання
            alert('URL скопійовано в буфер обміну: ' + urlToCopy);
        }
    }
});
